<div *ngIf="showGlobalLoader">
    <div class="loader-overlay">
        <h1>Loading</h1>
    </div>
</div>
